import { useState } from 'react';

interface AccordionItem {
  title: string;
  content: string;
}

interface ProductAccordionsProps {
  details: string;
  careInstructions: string;
}

export default function ProductAccordions({ details, careInstructions }: ProductAccordionsProps) {
  const items: AccordionItem[] = [
    {
      title: 'Product Details',
      content: details,
    },
    {
      title: 'Care Instructions',
      content: careInstructions,
    },
    {
      title: 'Shipping & Returns',
      content:
        'Orders are typically dispatched within 1-2 business days from our warehouse. Delivery timelines vary by pincode — our team will confirm ETA over WhatsApp when you place your order. We offer a 7-day exchange policy on all unworn, undamaged items in their original packaging. For quality defects, we accept returns within 30 days of delivery. To initiate an exchange or return, simply message us on WhatsApp and our team will guide you through the process.',
    },
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="flex flex-col divide-y divide-background-200/70 border-t border-b border-background-200/70">
      {items.map((item, index) => (
        <div key={index}>
          <button
            onClick={() => toggle(index)}
            className="w-full flex items-center justify-between py-4 text-left cursor-pointer group"
          >
            <h3 className="text-sm font-heading font-semibold text-primary-500">
              {item.title}
            </h3>
            <div
              className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${
                openIndex === index ? 'rotate-180' : ''
              }`}
            >
              <i className="ri-arrow-down-s-line text-foreground-400 group-hover:text-accent-500 transition-colors"></i>
            </div>
          </button>
          <div
            className={`overflow-hidden transition-all duration-300 ${
              openIndex === index ? 'max-h-[500px] pb-4' : 'max-h-0'
            }`}
          >
            <p className="text-sm text-foreground-600 leading-relaxed font-label whitespace-pre-line">
              {item.content}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}